import { defineMessages } from 'react-intl';

/**
 * SWITCH edu-ID login messages (#961).
 *
 * These strings are used from components under src/customizations/, which
 * i18n extraction skips (see core/packages/scripts/i18n.cjs). Defining them
 * here — outside that directory — is what puts them in the catalogs.
 */
export default defineMessages({
  eduidLogin: {
    id: 'Login mit Switch edu-ID',
    defaultMessage: 'Login mit Switch edu-ID',
  },
  or: {
    id: 'oder',
    defaultMessage: 'oder',
  },
  authenticating: {
    id: 'Completing Switch edu-ID login',
    defaultMessage: 'Anmeldung wird abgeschlossen …',
  },
  authenticatingHint: {
    id: 'Please do not reload the page.',
    defaultMessage: 'Bitte laden Sie die Seite nicht neu.',
  },
});
